import { render } from "./DocPage.vue?vue&type=template&id=572b0de3"
import script from "./DocPage.vue?vue&type=script&lang=js"
export * from "./DocPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__